module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAECAYAAADfyyz1AAAAAXNSR0IArs4c6QAAARxJREFUOE9lU4FtwzAMk/ZC16v2xHZZ71uzAe0BIQtKii2nQAI7tkSKEuN8bl8AbkZc3YwkzKnN7kYzN+pLB0bAFZMP4izeuj/2axzNlTtilSdcmGHmknDnga14FHXGeAIMvsFRcbqOhHM9xJ8BP74/7ncjP0NVFC9cWHLG2SRsICE4cCW+CM7CWwOmWGThSgc9OANLPLlWwwN3CmriIz/5pzAEXoBoWOM+6t98f/xuRl6MCurTSsF9StoX0jJJFaPYuGtTStJ3J4Ro5URXs2Cd5bbtw0Ftkk1Ycp7qSUyB1FpDMm4u65K4EbiKKQijy6tdDyutk4wJ1FS1dGuXGwrzLCybWPHD2vM7h9zc0n+Pd3uqQdNZa+y/fezfL+R9tz9Jkfp0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(57).png
// module id = dAXd
// module chunks = 1